import Debug from 'debug';

const _createDebug = sub => new Debug(`nosturi${sub.length ? ':' : ''}${sub}`);

const subs = {};
export const createDebug = (sub = '') => {
  if (subs[sub]) return subs[sub];
  const debug = _createDebug(sub);
  return (subs[sub] = debug);
};

const debug = createDebug();

export default debug;



// WEBPACK FOOTER //
// ./src/debug.js